module.exports = __webpack_public_path__ + "TooltipBlobMobile___1D7Ca.svg";